/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import percent_widthImg from 'assets/images/percent-width.jpg'

export const _6 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>6 - Правила responsive верстки</h2>
    <p className={styles.description}>
      В этом разделе мы познакомимся с методами, которые применяются при responsive верстке.{' '}
    </p>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>6.1 - width в %</h3>
      <p className={styles.description}>
        Итак, ширины блоков мы задаем не в px, а в процентах. Таким образом, когда макет сжимается на крошечном
        мобильном устройстве или растягивается через огромный экран, все элементы в макете будут изменять их ширину по
        отношению друг к другу.{' '}
      </p>
      <p className={styles.description}>
        Чтобы рассчитать пропорции для каждого элемента страницы, вы должны разделить целевой элемент на его контекст. В
        настоящее время лучший способ сделать это - сначала открыть макет в редакторе, таком как Photoshop. Благодаря
        высокому качеству макета, вы можете измерить элемент страницы и разделить его на всю ширину страницы.{' '}
      </p>
      <p className={styles.description}>
        Например, если ваш макет по ширине равен 960 пикселям, тогда это будет ваше «контейнерное» значение.
        Предположим, что наш целевой элемент - это какое-то произвольное значение, например, 300 пикселей в ширину. Если
        умножить результат на 100, мы получим процентное значение 31,25%, которое мы можем применить к целевому
        элементу.
      </p>
      <img className={styles.img} src={percent_widthImg} alt="percent-width" />
      <p className={styles.notificationWarn}>
        Если результирующее значение процентов получилось не целым, и вы получаете некоторое значение с плавающей
        точкой, не округляйте значение! Окончательный внешний вид страницы выиграет от кажущейся чрезмерной
        математической точности.{' '}
      </p>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>6.2 - min и max width</h3>
      <p className={styles.description}>
        Важной частью отзывчивого дизайна является использование минимальных/максимальных ширин контейнеров в пикселях
        (или rem/em) и ширин в % для контента внутри контейнеров. При responsive верстке не может быть фиксированных
        ширин в пикселях даже у оберток(дальше контейнер), может быть только максимальная/минимальная ширина. Это
        сделано для того чтобы контейнер растягивался на 100% текущей ширины окна браузера, но не растягивался больше
        чем максимальная ширина указанная в макете.{' '}
      </p>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>6.3 - Пример</h3>
      <p className={styles.description}>
        Напишем следующий HTML - контейнер для трех колонок, левого и правого сайдбаров и контентной части. Зададим
        контейнеру display flex, и высоту 200px для наглядности. К примеру, на макете content это обертка шириной 960px.
        Обратите внимание на max-width: 960px.{' '}
      </p>
      <p className={styles.description}>
        А теперь, к примеру, на макете мы отмеряли ширины left и right sidebar по 240px . Вместо того чтобы задать им
        ширину 240px, мы считаем ширину в процентах от общей ширины container.{' '}
      </p>
      <p className={styles.description}>width = 240 / 960 = 0.25 </p>
      <p className={styles.description}>Помним, что для получения процентов нужно умножать результат на 100. </p>
      <p className={styles.description}>width в % = 0.25 * 100 = 25% </p>
      <p className={styles.description}>
        Так же мы можем замерить ширину content и высчитать ее. Допустим у нас получится 50% для articles, оставшееся
        свободное пространство.{' '}
      </p>
      <p className={styles.description}>
        Получилась классическая «резиновая» верстка. Теперь если вы будете растягивать или сужать окно браузера, верстка
        будет подстраиваться под текущую ширину экрана. Ширина sidebar'ов всегда будет равна по 25% от общей ширины,
        articles 50%.{' '}
      </p>
      <iframe
        height="300"
        scrolling="no"
        title="rotman_html_1_9_1"
        src="https://codepen.io/rotmanyan/embed/ZJexNx?default-tab=html%2Cresult&editable=true&theme-id=dark"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>6.4 - margin</h3>
      <p className={styles.description}>
        Горизонтальный margin для блоков задается в процентах. Если бы по макету у нас были зазоры между articles и
        сайдбарами, и допустим articles был бы 46% шириной. Тогда ширины блоков выглядели бы следующим образом.{' '}
      </p>
      <ul className={styles.list}>
        <li className={styles.list__item}>articles - 46%</li>
        <li className={styles.list__item}>left-sidebar - 25%</li>
        <li className={styles.list__item}>right-sidebar - 25%</li>
        <li className={styles.list__item}>articles левый и правый margin был бы по 2%</li>
      </ul>
      <p className={styles.description}>
        Итого занято 100% ширины content. Конечно, если мы используем Flexbox, то достаточно задать justify-content:
        space-between, явно задавать margin не надо. Зазоры между колонками все равно будут по 2%.{' '}
      </p>
      <p className={styles.notificationWarn}>
        Не забывайте о том, что горизонтальный margin у блоков задается в % от ширины родителя. В то же время
        горизонтальный margin у элементов блока задается в rem. К примеру, блок статей. Если горизонтальный margin между
        статьями задается в %, то margin элементов внутри статьи задается в rem. Это не абсолютное правило, скорее
        хорошая практика.{' '}
      </p>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>6.5 - padding</h3>
      <p className={styles.description}>
        В отличие от margin, в 99% случаев при responsive верстке, вертикальный и горизонтальный padding задается в
        rem\em.{' '}
      </p>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>6.6 - Подведем итоги</h3>
      <p className={styles.description}>
        Это отличный подход к созданию отзывчивой веб страницы, но не все так просто. Когда ширина браузера становится
        слишком узкой, страница может начать сильно искажаться. Например, сложный трехколоночный макет не очень хорошо
        работает на небольшом мобильном телефоне. К счастью, отзывчивый дизайн позаботился об этой проблеме, используя
        медиа-запросы, о них позже.{' '}
      </p>
    </section>
  </section>
))
